import CardsVisualization2021 from "../../../../src/data/articles/2021-standard-rotation-cube-retrospective/CardsVisualization.tsx";
import SetStatistics2021 from "../../../../src/data/articles/2021-standard-rotation-cube-retrospective/SetStatistics.tsx";
import SetList2021 from "../../../../src/data/articles/2021-standard-rotation-cube-retrospective/SetList.tsx";
import * as React from 'react';
export default {
  CardsVisualization2021,
  SetStatistics2021,
  SetList2021,
  React
};